import { LoadingSpinner } from '@web_opxp/components';
import { LanguageSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { TRAINING_DOMAINS } from '../base/constants';
import ENV from '../base/env';
import { EDomain } from '../base/types';
import LevelSection from '../components/LevelSection/LevelSection';
import { CyclesSelectors } from '../cycles';
import Day0Banner from '../d0banner/Day0Banner';
import { IState } from '../store/state';
import DomainContainer from './DomainContainer';
import { ExercisesActions } from './slice';

export const ExercisesRoute = '/exercises';

export interface IExercisesPageProps {
  loaded: boolean;
  sessionDomain?: EDomain;
  onStart: () => void;
}

export const ExercisesPageFC: React.FC<IExercisesPageProps> = ({ loaded, sessionDomain, onStart }) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    if (loaded) {
      onStart();
    }
  }, [loaded, onStart]);
  if (!loaded) return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  const notRecommendedDomains = TRAINING_DOMAINS.filter((domain) => domain !== sessionDomain);
  return (
    <>
      <Day0Banner />
      <LevelSection title={t('ChooseExercise.Title')} subtitle={t('ChooseExercise.Description')} />
      <DomainContainer domain={sessionDomain} recommended={true} />
      {notRecommendedDomains.map((domain) => (
        <DomainContainer key={domain} domain={domain} />
      ))}
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const appLoaded = !CyclesSelectors.isCyclesLoading(state);
  const localeLoaded = !LanguageSelectors.isLoading(state);
  const sessionDomain = CyclesSelectors.getCurrentSessionDomain(state);
  const loaded = appLoaded && localeLoaded;
  return {
    loaded,
    sessionDomain,
  };
};

export const mapDispatchToProps = {
  onStart: ExercisesActions.openExercises,
};

const Exercises = connect(mapStateToProps, mapDispatchToProps)(ExercisesPageFC);
export default Exercises;
